import React from "react";

const CommonRequiredLabel = ({ label, required = false, style }) => (
  <p style={style}>
    {label} {required ? <span style={{ color: "red" }}>*</span> : ""}
  </p>
);

export default CommonRequiredLabel;
